import React, { useMemo, useState } from "react";

import ShellCard from "components/ShellCard";

import { fmtBRL, fmtInt } from "../../ConferenciaFatura/formatters";
import renderEstadoSecao from "./EstadoSecao";

const EYEBROW = "O que trava";
const TITULO = "Motivos de bloqueio e travamento";
const DESCRICAO =
  "As cinco categorias aparecem sempre, mesmo zeradas: “nenhuma fatura bloqueada no período” é resposta, não ausência de dado. Os textos vêm da justificativa registrada na conciliação, já normalizados (número da fatura e nome do arquivo XML fora) para o mesmo erro não virar 20 motivos diferentes.";

/**
 * Seção da H3 (PO1-3001): top motivos por categoria. O backend devolve as 5
 * categorias na ordem fixa BLO, CON, NAO_LIBERADA, ERRO_INTEGRACAO, CTE_NOK,
 * cada uma com no máximo 20 motivos ordenados por faturas.
 */
export default function MotivosBloqueio({ estado }) {
  const [abertas, setAbertas] = useState({});

  const categorias = (estado && estado.data && estado.data.categorias) || [];

  // Abre por padrão a categoria que mais trava fatura — é onde o time age.
  // Uma escolha derivada dos dados, não um efeito: sem estado extra para
  // sincronizar quando o filtro muda.
  const categoriaPadrao = useMemo(() => {
    let alvo = null;
    categorias.forEach((c) => {
      if (c.faturas > 0 && (!alvo || c.faturas > alvo.faturas)) alvo = c;
    });
    return alvo ? alvo.categoria : null;
  }, [categorias]);

  const bloqueio = renderEstadoSecao(estado, "Sem motivos registrados no período.");

  if (bloqueio) {
    return (
      <ShellCard eyebrow={EYEBROW} title={TITULO} description={DESCRICAO}>
        {bloqueio}
      </ShellCard>
    );
  }

  return (
    <ShellCard eyebrow={EYEBROW} title={TITULO} description={DESCRICAO}>
      <ul className="lt-motivos">
        {categorias.map((c) => {
          const aberta =
            abertas[c.categoria] === undefined
              ? c.categoria === categoriaPadrao
              : abertas[c.categoria];
          const temMotivos = c.motivos.length > 0;

          return (
            <li
              key={c.categoria}
              className={`lt-motivos__cat lt-cat--${c.categoria}${
                c.faturas ? "" : " is-vazia"
              }`}
            >
              <button
                type="button"
                className="lt-motivos__head"
                disabled={!temMotivos}
                aria-expanded={aberta && temMotivos}
                onClick={() =>
                  setAbertas((atual) => ({ ...atual, [c.categoria]: !aberta }))
                }
              >
                <span className="lt-motivos__nome">
                  <span className="lt-dot" />
                  {c.nome}
                </span>
                <span className="lt-motivos__numeros">
                  <span>
                    <em>{fmtInt(c.faturas)}</em> fatura(s)
                  </span>
                  <span>
                    <em>{fmtInt(c.ocorrencias)}</em> ocorrência(s)
                  </span>
                  <span>{fmtBRL(c.valorTotal)}</span>
                </span>
                <span className="lt-motivos__toggle">
                  {temMotivos ? (
                    <i
                      className={`tim-icons ${
                        aberta ? "icon-minimal-up" : "icon-minimal-down"
                      }`}
                    />
                  ) : null}
                </span>
              </button>

              {temMotivos && aberta ? (
                <ol className="lt-motivos__lista">
                  {c.motivos.map((m, i) => (
                    <li key={`${c.categoria}-${i}`} className="lt-motivos__item">
                      <span className="lt-motivos__texto" title={m.motivo}>
                        {m.motivo}
                      </span>
                      <span className="lt-motivos__item-num">
                        {fmtInt(m.faturas)} fat. · {fmtInt(m.ocorrencias)} ocor. ·{" "}
                        {fmtBRL(m.valorTotal)}
                      </span>
                    </li>
                  ))}
                </ol>
              ) : null}

              {!temMotivos ? (
                <p className="lt-motivos__vazia">Nenhuma ocorrência no período.</p>
              ) : null}
            </li>
          );
        })}
      </ul>
    </ShellCard>
  );
}
